import React from 'react';

const BackInStockIcon = (props) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" id="backinstock-icon" viewBox="0 0 850 846">
    <path fillRule="evenodd" clipRule="evenodd" d="M434.881 55.0508C428.539 52.5091 421.461 52.5091 415.119 55.0508L98.0687 181.86L225.781 232.913L552.713 102.173L434.881 55.0508ZM624.219 130.807L297.288 261.548L425 312.601L751.931 181.86L624.219 130.807ZM796.875 221.12L451.562 359.245V780.101L796.875 641.976V221.173V221.12ZM398.438 780.154V359.191L53.125 221.12V642.029L398.438 780.154ZM395.409 5.69769C414.405 -1.89923 435.595 -1.89923 454.591 5.69769L833.319 157.21C838.243 159.184 842.463 162.586 845.436 166.979C848.409 171.373 849.999 176.555 850 181.86V642.029C849.993 652.644 846.806 663.015 840.85 671.802C834.894 680.589 826.442 687.391 816.584 691.329L434.881 844.01C428.539 846.552 421.461 846.552 415.119 844.01L33.4688 691.329C23.6008 687.399 15.1376 680.601 9.17161 671.813C3.20565 663.025 0.0109612 652.651 0 642.029L0 181.86C0.00123462 176.555 1.59076 171.373 4.56381 166.979C7.53686 162.586 11.7572 159.184 16.6812 157.21L395.409 5.69769Z" fill="url(#paint0_linear)"/>
    <defs>
    <linearGradient id="paint0_linear" x1="425" y1="0" x2="425" y2="845.917" gradientUnits="userSpaceOnUse">
    <stop offset="0.0572917" stopColor="#8B3CCA"/>
    <stop offset="1" stopColor="#EE8ECD" stopOpacity="0.74"/>
    </linearGradient>
    </defs>
    </svg>

  );
}


export { BackInStockIcon };
